export enum RoutePath {
    ChangePassword = '/settings/change-password',
    Enable2FA = '/settings/enable-2fa',
    InvoiceDetails = '/invoices/:id',
    Invoices = '/invoices',
    Login = '/login',
    Notifications = '/notifications',
    Payment = '/payment/:formId',
    Reports = '/reports',
    Merchant = '/merchant',
    Settings = '/settings',
    Terminals = '/terminals',
    Monitoring = '/monitoring',
    Accounts = '/accounts',
    AccountDetails = '/accounts/:id',
}
